<template>
  <div>
    <div class="card no-margin-bottom">
      <div class="card-block">
        <ui-data-table
          id="accounts-list"
          ref="list"
          :columns="columns"
          :filters="isAdmin ? filters : []"
          :endpoint="endpoint"
          :actions="isAdmin ? actions : []"
          size="sm"
        >
          <template slot="id" slot-scope="row">
            <router-link
              v-if="isAdmin"
              :to="{ name: 'UsersEditAccount', params: { id: row.id } }"
            >
              {{ row.id }}
            </router-link>
          </template>
          <template slot="users" slot-scope="row">
            <router-link
              :to="{
                name: 'UsersUsers',
                query: { 'filter.account_id': '=' + row.id },
              }"
            >
              {{ row.users.length }}
            </router-link>
          </template>
          <template slot="vendors" slot-scope="row">
            <!-- <template v-if="row['vendor_credentials'].length > 0"> -->
            <template>
              <a
                href="#"
                @click.prevent="showVendorCredentialsModal(row['id'])"
              >
                {{ row["vendor_credentials"].length }}
              </a>
            </template>
            <!-- <template v-else>
              {{ row["vendor_credentials"].length }}
            </template> -->
          </template>
          <template slot="marketplaces" slot-scope="row">
            <!-- <template v-if="row['marketplace_credentials'].length > 0"> -->
            <template>
              <a
                href="#"
                @click.prevent="showMarketplaceCredentialsModal(row['id'])"
              >
                {{ row["marketplace_credentials"].length }}
              </a>
            </template>
            <!-- <template v-else>
              {{ row["marketplace_credentials"].length }}
            </template> -->
          </template>

          <template slot="order_logs" slot-scope="row">
            <router-link
              class="text-primary"
              :to="{ name: 'OrderLogs', params: { id: row.id } }"
            >
              View
            </router-link>
          </template>

          <template slot="inventory_logs" slot-scope="row">
            <router-link
              class="text-primary"
              :to="{ name: 'InventoryLogs', params: { id: row.id } }"
            >
              View
            </router-link>
          </template>

          <template slot="billable_plan" slot-scope="row">
            <span>{{ row.billable_plan ? row.billable_plan.name : "-" }}</span>
          </template>
          <template slot="billing_plan" slot-scope="row">
            <span>{{ row.billing_plan ? row.billing_plan.name : "-" }}</span>
          </template>

          <template slot="is_active" slot-scope="row">
            <i v-if="row.is_active === true" class="fa fa-check text-success" />
          </template>
        </ui-data-table>
      </div>
    </div>

    <router-view />

    <app-vendor-credentials-manage-for-account-modal
      v-model="vendorCredentials.visible"
      :account-id="vendorCredentials.accountId"
      @updated="refresh"
    />

    <app-marketplace-credentials-manage-for-account-modal
      v-model="marketplaceCredentials.visible"
      :account-id="marketplaceCredentials.accountId"
      @updated="refresh"
    />
  </div>
</template>

<script>
import ApiService from "../services/ApiService";
import ErrorsMixins from "../mixins/ErrorsMixins";
import AppVendorCredentialsManageForAccountModal from "../components/vendor-credentials/VendorCredentialsManageForAccountModal.vue";
import AppMarketplaceCredentialsManageForAccountModal from "../components/marketplace-credentials/MarketplaceCredentialsManageForAccountModal.vue";
import UsersRoleModel from "../models/UsersRoleModel";
export default {
  name: "AppPageAccounts",
  components: {
    AppMarketplaceCredentialsManageForAccountModal,
    AppVendorCredentialsManageForAccountModal,
  },
  mixins: [ErrorsMixins],
  data() {
    return {
      columns: [
        {
          name: "ID",
          key: "id",
          sorting: true,
          styles: "text-right",
        },
        {
          name: this.$t("Name"),
          key: "name",
          sorting: true,
        },
        // {
        //   name: this.$tc('Users', 2),
        //   key: 'users',
        //   styles: 'text-right',
        // },
        // {
        //   name: this.$tc('Vendors', 2),
        //   key: 'vendors',
        //   styles: 'text-right',
        // },
        // {
        //   name: this.$tc('Marketplaces', 2),
        //   key: 'marketplaces',
        //   styles: 'text-right',
        // },
        // {
        //   name: this.$t('Enabled'),
        //   key: 'is_active',
        //   sorting: true,
        //   styles: 'text-center',
        // },
      ],
      filters: [
        {
          name: "ID",
          key: "id",
          type: "integer",
        },
        {
          name: this.$t("Name"),
          key: "name",
          type: "string",
        },
      ],
      endpoint: `${ApiService.getLink(
        "accounts"
      )}&includes=users,marketplaceCredentials,vendorCredentials,billablePlan&appends=billing_plan`,
      actions: [
        {
          icon: "fa fa-plus",
          action: () => {
            this.$router.push({ name: "UsersCreateAccount" });
          },
          label: this.$t("Create object", {
            object: this.$tc("Accounts", 1).toLowerCase(),
          }),
        },
      ],
      vendorCredentials: {
        visible: false,
        accountId: 0,
      },
      marketplaceCredentials: {
        visible: false,
        accountId: 0,
      },
    };
  },
  methods: {
    showVendorCredentialsModal(accountId) {
      this.vendorCredentials.accountId = accountId;
      this.vendorCredentials.visible = true;
    },
    showMarketplaceCredentialsModal(accountId) {
      this.marketplaceCredentials.accountId = accountId;
      this.marketplaceCredentials.visible = true;
    },
    refresh() {
      this.$refs.list.refresh();
    },
  },
  computed: {
    isAdmin() {
      return this.user().roles.some((role) => role.id === UsersRoleModel.ROLE_SUPERADMIN);
    },
  },
  created() {
    if (this.isAdmin) {
      this.columns.push(
        {
          name: this.$tc("Users", 2),
          key: "users",
          styles: "text-right",
        },
        {
          name: this.$tc("Vendors", 2),
          key: "vendors",
          styles: "text-right",
        },
        {
          name: this.$tc("Marketplaces", 2),
          key: "marketplaces",
          styles: "text-right",
        }
      );
    }
    this.columns.push(
      {
        name: this.$tc("Order Logs", 2),
        key: "order_logs",
        styles: "text-right",
      },
      {
        name: this.$tc("Inventory Logs", 2),
        key: "inventory_logs",
        styles: "text-right",
      },
      {
        name: this.$t("Custom Plan"),
        key: "billable_plan",
        sorting: true,
      },
      {
        name: this.$t("Current Plan"),
        key: "billing_plan",
        sorting: true,
      }
    );
    // this.columns.push({
    //   name: this.$t("Enabled"),
    //   key: "is_active",
    //   sorting: true,
    //   styles: "text-center",
    // });
  },
};
</script>

